import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';
import { DoodleMascot } from '@/components/core/ThemeMascot/mascots';

export const doodleTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.DOODLE,
  hover: {
    transform: 'translateY(-5px) rotate(2deg)',
    transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  click: {
    transform: 'scale(0.92) rotate(-3deg)',
    transition: 'transform 0.12s ease-out',
  },
  idle: {
    animationName: 'playful-doodle-wobble',
    animationDuration: '2.8s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
  },
  dragStart: {
    transform: 'scale(1.05) rotate(-4deg)',
    transition: 'transform 0.2s ease-out',
  },
  particles: {
    enabled: true,
    count: 6,
    characters: ['✏️', '📝', '🎨', '💭'],
    spread: 50,
    duration: 1100,
    size: 14,
  },
  keyframes: [
    {
      name: 'playful-doodle-wobble',
      css: `@keyframes playful-doodle-wobble {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(1deg); }
  75% { transform: rotate(-1deg); }
}`,
    },
  ],
  sounds: {
    hover: { name: 'ui/keystroke_soft', volume: 0.15 },
    click: { name: 'ui/button_medium', volume: 0.25 },
  },
  metadata: {
    label: 'Doodle',
    icon: IconName.EDIT,
    previewEmoji: '✏️',
    description: 'Hand-drawn wobble',
    mascotEmoji: '✏️',
    mascotComponent: DoodleMascot,
  },
};
